{
  "period.member.editAction": "Üyeliği düzenle",
  "period.member.editTitle": "Dönem üyeliğini düzenle",
  "period.member.saveAction": "Üyeliği kaydet",
  "period.member.role": "Bu dönemdeki rol",
  "period.member.note": "Döneme özel not",
  "period.member.order": "Görüntüleme sırası",
  "period.member.error": "Üyelik güncellenemedi. Değişiklikleriniz yeniden denemek için korunuyor."
}
